import { useTranslation } from 'react-i18next';
import './skipLink.css';

export default function SkipLink() {
  const { t } = useTranslation();

  return (
    <>
      <a href='#navigation' className='skip-link'>
        {t('skipLink.toNav')}
      </a>
      <a href='#main' className='skip-link'>
        {t('skipLink.toContent')}
      </a>
    </>
  );
}
